import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import './CommunesList.css';

interface Commune {
  id: number;
  name: string;
  project_count: number;
  created_at?: string;
}

interface CommunesListProps {
  onSelectCommune: (communeId: number, communeName: string) => void;
}

const CommunesList: React.FC<CommunesListProps> = ({ onSelectCommune }) => {
  const [communes, setCommunes] = useState<Commune[]>([]);
  const [search, setSearch] = useState('');
  const [filterWithProjects, setFilterWithProjects] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCommunes();
  }, []);

  useEffect(() => {
    loadCommunes();
  }, [search, filterWithProjects]);

  const loadCommunes = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.append('q', search);
      if (filterWithProjects) params.append('with_projects', 'true');
      
      const response = await fetch(`${API_URL}/communes/search?${params}`);
      const data = await response.json();
      setCommunes(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error loading communes:', error);
      setCommunes([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="communes-list">
      <div className="communes-header">
        <div className="search-bar">
          <input
            type="text"
            placeholder="🔍 Tapez au moins 2 caractères pour rechercher..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <label className="filter-checkbox">
          <input
            type="checkbox"
            checked={filterWithProjects}
            onChange={(e) => setFilterWithProjects(e.target.checked)}
          />
          <span>Afficher uniquement les communes avec projets</span>
        </label>
      </div>

      {loading && (
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Recherche en cours...</p>
        </div>
      )}

      {!loading && communes.length > 0 && (
        <div className="communes-grid">
          {communes.map((commune) => (
            <div
              key={commune.id}
              className="commune-card"
              onClick={() => onSelectCommune(commune.id, commune.name)}
            >
              <div className="commune-name">
                {commune.project_count > 0 && <span className="project-icon">📁</span>}
                {commune.name}
              </div>
              {commune.project_count > 0 && (
                <div className="project-count">
                  {commune.project_count} projet(s)
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {!loading && communes.length === 0 && (
        <div className="empty-state">
          <p>Aucune commune trouvée</p>
        </div>
      )}
    </div>
  );
};

export default CommunesList;
